<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      height: calc(100vh - 120px);
      gap: 12px;
    "
  >
    <div style="display: flex; justify-content: space-between; align-items: center">
      <h1 class="h3" style="margin-bottom: 0">
        {{ $t('transferStock.title') }}
      </h1>
      <div style="display: flex; gap: 8px">
        <a-button
          v-if="!flagWms"
          type="primary"
          :disabled="isLoading"
          @click="toImportTransfer"
        >
          <a-icon type="import" />
          {{ $t('transferStock.buttons.importTitle') }}
        </a-button>
        <a-button
          v-if="params.warehouse_id && !flagWms"
          type="primary"
          :disabled="isLoading"
          @click="toCreateTransfer"
        >
          <a-icon type="plus-circle" />
          {{ $t('transferStock.createButton') }}
        </a-button>
      </div>
    </div>
    <div
      style="display: flex; flex-direction: row; gap: 24px; align-items: flex-start"
    >
      <div v-if="restriction === 'Business'" style="width: 300px">
        <a-select
          v-model="params.warehouse_id"
          allow-clear
          show-search
          class="w-100 select-antd-default"
          option-filter-prop="children"
          :filter-option="filterOption"
          :placeholder="$t('transferStock.optionGudang')"
          :options="warehouseList"
          :disabled="isLoading"
          @change="handleChangeWarehouse"
        />
      </div>
      <a-input-search
        v-model="params.search"
        allow-clear
        style="width: 320px"
        :enter-button="$t('transferStock.buttons.search')"
        :placeholder="$t('transferStock.searchPlaceHolder')"
        :loading="isLoading"
        @search="handleSearch"
      />
      <a-range-picker
        v-model="dateRange"
        style="width: 350px"
        :format="dateFormat"
        :placeholder="[
          $t('transferStock.filters.startDate'),
          $t('transferStock.filters.endDate'),
        ]"
        :disabled="isLoading"
        :ranges="dateRangePresets"
        allow-clear
        @change="handleDateRangeChange"
      />
      <div style="flex: 1" />
      <div style="display: flex; align-items: center; gap: 8px">
        <span>{{ $t('transferStock.labels.sortBy') }}</span>
        <a-select
          v-model="params.sort"
          style="width: 180px"
          class="select-antd-default"
          @change="handleChangeSort"
        >
          <a-select-option
            v-for="item in sorts"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div v-if="restriction === 'Business' && !params.warehouse_id">
      <a-alert
        :message="$t('transferStock.messages.warningSelectWarehouse')"
        type="warning"
        show-icon
        class="mb-0"
        style="width: fit-content"
      />
    </div>
    <div>
      <a-table
        style="border: 1px solid #e4e9f0; border-radius: 5px"
        size="middle"
        :data-source="listData"
        :row-key="record => record.id"
        :columns="columns"
        :loading="isLoading"
        :pagination="false"
        class="data-list"
        :scroll="scroll"
        :custom-row="record => ({ on: { click: () => viewDetail(record) } })"
      >
        <template slot="source_warehouse_id" slot-scope="text">
          <div class="cell-warehouse">
            <a-tooltip :title="getWarehouseName(text)">
              <span class="wh-ellipsis">{{ getWarehouseName(text) }}</span>
            </a-tooltip>
          </div>
        </template>
        <template slot="destination_warehouse_id" slot-scope="text">
          <div class="cell-warehouse">
            <a-tooltip :title="getWarehouseName(text)">
              <span class="wh-ellipsis">{{ getWarehouseName(text) }}</span>
            </a-tooltip>
          </div>
        </template>
        <template slot="date" slot-scope="text">
          <div class="cell-date">
            <a-tooltip :title="$moment(text).format('DD MMM YYYY - HH:mm')">
              <time
                :datetime="$moment(text).format('YYYY-MM-DDTHH:mm:ssZ')"
                class="mw-100 d-inline-block text-truncate time-sm mono-sm"
              >
                {{ $moment(text).format('DD MMM YYYY') }}
              </time>
            </a-tooltip>
          </div>
        </template>
        <template slot="number" slot-scope="text">
          <div class="cell-number">
            <a-tooltip :title="text">
              <span class="mono-sm">{{ text }}</span>
            </a-tooltip>
            <a-tooltip :title="$t('transferStock.messages.copy')">
              <a-icon
                type="copy"
                class="copy-icon"
                @click.stop="copyNumber(text)"
              />
            </a-tooltip>
          </div>
        </template>
        <template slot="sent_by" slot-scope="text">
          <div class="cell-actor">
            <a-tooltip :title="text?.user_name || '-'">
              <span class="actor-ellipsis">{{ text?.user_name || '-' }}</span>
            </a-tooltip>
          </div>
        </template>
        <template slot="receipt_by" slot-scope="text">
          <div class="cell-actor">
            <a-tooltip :title="text?.user_name || '-'">
              <span class="actor-ellipsis">{{ text?.user_name || '-' }}</span>
            </a-tooltip>
          </div>
        </template>
        <template slot="status" slot-scope="text">
          <a-tag :color="statusColor(text)">
            {{ normalizeStatus(text) }}
          </a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="action-cell">
            <a-dropdown placement="bottomRight">
              <a @click.stop.prevent="">
                <a-icon type="more" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    key="detail"
                    class="py-2"
                    @click="viewDetail(record)"
                  >
                    <a-icon type="info-circle" class="mr-1" />
                    {{ $t('transferStock.actions.viewDetail') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="
                      normalizeStatus(record.status) === 'CREATED' &&
                        String(record.source_warehouse_id) ===
                        String(selectedWarehouseId)
                    "
                    key="ship"
                    class="py-2"
                    @click="shipTransfer(record)"
                  >
                    <a-icon type="arrow-right" class="mr-1" />
                    {{ $t('transferStock.actions.send') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="
                      normalizeStatus(record.status) === 'SHIPPED' &&
                        String(record.destination_warehouse_id) ===
                        String(selectedWarehouseId)
                    "
                    key="receive"
                    class="py-2"
                    @click="receiveTransfer(record)"
                  >
                    <a-icon type="download" class="mr-1" />
                    {{ $t('transferStock.actions.receive') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="
                      ['CREATED', 'SHIPPED'].includes(
                        normalizeStatus(record.status),
                      ) &&
                        String(record.source_warehouse_id) ===
                        String(selectedWarehouseId)
                    "
                    key="cancel"
                    class="py-2"
                    @click="cancelTransfer(record)"
                  >
                    <a-icon type="close-circle" class="mr-1" />
                    {{ $t('transferStock.actions.cancel') }}
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
        <template slot="footer">
          <a-pagination
            v-model="params.page"
            style="display: flex; justify-content: flex-end"
            :page-size="params.size"
            :page-size-options="sizeOptions"
            :total="totalRow"
            :show-total="
              (total, range) =>
                $t('utils.pagination_show_total', {
                  perpage: `${range[0]} - ${range[1]}`,
                  total,
                })
            "
            :disabled="isLoading"
            show-size-changer
            :locale="{ items_per_page: $t('utils.items_per_page') }"
            @change="onPageChange"
            @showSizeChange="onShowSizeChange"
          />
        </template>
      </a-table>
    </div>
    <a-modal
      :visible="showErrorModal"
      :title="errorTitle || 'Kesalahan Validasi'"
      width="720px"
      :footer="null"
      @cancel="showErrorModal = false"
    >
      <a-table
        style="border: 1px solid #e4e9f0; border-radius: 5px"
        :columns="errorColumns"
        :data-source="errorItems"
        :pagination="{ pageSize: 10, showSizeChanger: true, locale: { items_per_page: $t('utils.items_per_page') } }"
        size="middle"
        :row-key="(r, i) => i"
      >
        <template slot="item" slot-scope="text">
          <span class="mono-sm" style="white-space: nowrap">
            {{ text }}
          </span>
        </template>
      </a-table>
      <div class="mt-3 text-right">
        <a-button type="primary" @click="showErrorModal = false">
          Tutup
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { columsAdjustment } from '@/data/columns'
import {
  getTransferWarehouseList,
  getTransferWarehouseDetail,
  cancelTransferNonWms,
  sendTransferNonWms,
  receiveTransferNonWms,
} from '@/api/inventory'
import { getWarehouseListByWorkspace, getWarehouseInternal } from '@/api/warehouse'
import debounce from 'lodash/debounce'

export default {
  name: 'TransferStockIndex',
  data() {
    return {
      isLoading: false,
      totalRow: 50,
      warehouseList: [],
      fullWarehouseList: [],
      listData: [],
      sizeOptions: ['50', '100', '200'],
      params: {
        warehouse_id: this.$route.query.warehouse_id || undefined,
        search: this.$route.query.search || '',
        sort: this.$route.query.sort || 'date,Desc',
        business_id: this.$route.query.business_id
          ? this.$route.query.business_id
          : Object.keys(this.$store.getters['user/businessListObjectByKey'])[0],
        page: 1,
        size: 50,
      },
      dateRange: [],
      dateFormat: 'DD MMM YYYY',
      selectedWarehouseId:
        this.$route.query.warehouse_id ||
        this.$route.query.warehouseId ||
        undefined,
      flagWms: false,
      // viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 600,
      prevBodyOverflow: '',
      prevHtmlOverflow: '',
      showErrorModal: false,
      errorTitle: '',
      errorItems: [],
    }
  },
  computed: {
    scroll() {
      return {
        x: '100%',
      }
    },
    errorColumns() {
      return [
        {
          title: this.$t('transferStock.columns.item') || 'Item',
          dataIndex: 'item',
          key: 'item',
          width: 220,
          scopedSlots: { customRender: 'item' },
        },
        { title: this.$t('transferStock.columns.reason') || 'Alasan', dataIndex: 'reason', key: 'reason' },
      ]
    },
    dateRangePresets() {
      return {
        [this.$t('transferStock.datePresets.today')]: [
          this.$moment().startOf('day'),
          this.$moment().endOf('day'),
        ],
        [this.$t('transferStock.datePresets.thisMonth')]: [
          this.$moment().startOf('month'),
          this.$moment().endOf('month'),
        ],
        [this.$t('transferStock.datePresets.thisYear')]: [
          this.$moment().startOf('year'),
          this.$moment().endOf('year'),
        ],
        [this.$t('transferStock.datePresets.last7Days')]: [
          this.$moment().subtract(6, 'days').startOf('day'),
          this.$moment().endOf('day'),
        ],
        [this.$t('transferStock.datePresets.last30Days')]: [
          this.$moment().subtract(29, 'days').startOf('day'),
          this.$moment().endOf('day'),
        ],
        [this.$t('transferStock.datePresets.last1Year')]: [
          this.$moment().subtract(1, 'year').add(1, 'day').startOf('day'),
          this.$moment().endOf('day'),
        ],
      }
    },
    restriction() {
      return this.$store.state.user.restriction_base
    },
    businessId() {
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id
    },
    columns() {
      return [
        { title: this.$t('transferStock.columns.date'), dataIndex: 'date', key: 'date', width: 120, align: 'center', scopedSlots: { customRender: 'date' } },
        { title: this.$t('transferStock.columns.number'), dataIndex: 'number', key: 'number', scopedSlots: { customRender: 'number' } },
        { title: this.$t('transferStock.columns.sourceWarehouse'), dataIndex: 'source_warehouse_id', key: 'source_warehouse_id', align: 'center', scopedSlots: { customRender: 'source_warehouse_id' } },
        { title: this.$t('transferStock.columns.destinationWarehouse'), dataIndex: 'destination_warehouse_id', key: 'destination_warehouse_id', align: 'center', scopedSlots: { customRender: 'destination_warehouse_id' } },
        { title: this.$t('transferStock.columns.sender'), dataIndex: 'sent_by', key: 'sent_by', ellipsis: true, align: 'center', scopedSlots: { customRender: 'sent_by' } },
        { title: this.$t('transferStock.columns.receiver'), dataIndex: 'receipt_by', key: 'receipt_by', ellipsis: true, align: 'center', scopedSlots: { customRender: 'receipt_by' } },
        { title: this.$t('transferStock.columns.status'), dataIndex: 'status', key: 'status', width: 100, align: 'center', scopedSlots: { customRender: 'status' } },
        { title: '', dataIndex: 'action', key: 'action', width: 48, align: 'center', scopedSlots: { customRender: 'action' } },
      ]
    },
    sorts() {
      return [
        { value: 'date,Desc', label: this.$t('transferStock.sortByNewest') },
        { value: 'date,Asc', label: this.$t('transferStock.sortByOldest') },
      ]
    },
  },
  watch: {
    '$route.query'() {
      this.params.search = this.$route.query.search || ''
      this.params.sort = this.$route.query.sort || 'date,Desc'
      this.fetchWarehouseList()
    },
    businessId(newValue) {
      this.params.business_id = newValue
      this.fetchWarehouseList()
    },
    'params.warehouse_id'(value) {
      const item = this.warehouseList.find(
        v => String(v.value) === String(value),
      )
      const code =
        item && item.wms_code != null
          ? String(item.wms_code).trim().toUpperCase()
          : null
      const nonWms = code === null || code === '' || code === 'N/A'
      this.flagWms = !nonWms
    },
    'params.search'(value) {
      if (value === '') {
        this.params.page = 1
        const newQuery = { ...this.$route.query }
        delete newQuery.search
        newQuery.page = 1
        this.$router.push({ query: newQuery }).catch(() => {})
      }
    },
  },
  mounted() {
    this.fetchWarehouseList()
  },
  methods: {
    notifyError(e) {
      const data = e?.response?.data
      const title =
        data?.status ||
        data?.message ||
        e?.response?.status ||
        e?.message ||
        'Error'
      const description =
        data?.error ||
        data?.message ||
        e?.response?.statusText ||
        e?.message ||
        ''
      const errors = data?.data?.errors
      const isValidation =
        data?.message === 'ValidationError' || data?.error === 'ValidationError'
      if (isValidation && errors?.length) {
        this.errorTitle = String(title)
        this.errorItems = errors.map(it => ({
          item: String(it?.item),
          reason: String(it?.reason),
        }))
        this.showErrorModal = true
        return
      }
      this.$notification.error({ message: title, description })
    },
    fetchWarehouseList: debounce(async function () {
      try {
        // Fetch complete warehouse list for lookup (bypass restrictions)
        getWarehouseInternal({
          business_id: this.businessId,
          limit: 500,
        })
          .then(({ data }) => {
            const rawFull = data?.data?.data || data?.data || []
            this.fullWarehouseList = rawFull.map(w => ({
              value: String(w.id || w.warehouse_id),
              label: String(w.name || w.warehouse_name || '').trim(),
            }))
          })
          .catch(err => console.error('fetchFullWarehouseList error:', err))

        const { data: body } = await getWarehouseListByWorkspace({
          business_id: this.businessId,
        })
        const rawList = body?.data?.data || body?.data || []
        const list = rawList.map(w => ({
          ...w,
          value: String(w.id || w.warehouse_id),
          label: String(w.name || w.warehouse_name || '').trim(),
        }))
        this.warehouseList = list
        this.params.warehouse_id =
          this.$route.query.warehouse_id ||
          this.$route.query.warehouseId ||
          undefined
        this.selectedWarehouseId = this.params.warehouse_id
        this.params.search = this.$route.query.search || ''
        this.params.sort = this.$route.query.sort || 'date,Desc'
        
        if (!this.params.warehouse_id && list.length === 1) {
          const firstId = list[0].value
          this.params.warehouse_id = firstId
          this.selectedWarehouseId = firstId
          this.$router
            .push({
              query: {
                ...this.$route.query,
                warehouseId: firstId,
                page: 1,
              },
            })
            .catch(() => {})
        }
        
        const item = this.warehouseList.find(
          v => String(v.value) === String(this.params.warehouse_id),
        )
        const code =
          item && item.wms_code != null
            ? String(item.wms_code).trim().toUpperCase()
            : null
        const nonWms = !code || code === '' || code === 'N/A'
        this.flagWms = !nonWms
        this.fetchList()
      } catch (err) {
        this.warehouseList = []
        console.error('fetchWarehouseList error:', err)
      }
    }, 500),
    handleSearch(value) {
      this.params.search = value
      this.params.page = 1
      const newQuery = { ...this.$route.query, page: 1 }
      if (value && String(value).trim() !== '') {
        newQuery.search = value
      } else {
        delete newQuery.search
      }
      this.$router.push({ query: newQuery }).catch(() => {})
    },
    handleChangeSort(value) {
      this.params.sort = value
      this.params.page = 1
      const newQuery = { ...this.$route.query, sort: value, page: 1 }
      this.$router.push({ query: newQuery }).catch(() => {})
    },
    handleDateRangeChange(dates) {
      this.dateRange = dates || []
      this.params.page = 1
      this.fetchList()
    },
    handleChangeWarehouse(value) {
      this.params.warehouse_id = value
      this.selectedWarehouseId = value
      this.$router
        .push({
          query: { ...this.$route.query, warehouseId: value, page: 1 },
        })
        .catch(() => {})
    },
    async fetchList() {
      this.isLoading = true
      const [field, dirRaw] = (this.params.sort || 'date,Desc').split(',')
      const direction =
        String(dirRaw || 'Desc').toLowerCase() === 'asc' ? 'asc' : 'desc'
      const sorting = `${field}:${direction}`
      const filters = []
      if (this.params.search) filters.push(`number:${this.params.search}`)
      const status = this.$route.query.status
      if (status) filters.push(`status:${status}`)
      // Date range filter
      let startDate = undefined
      let endDate = undefined
      if (this.dateRange?.length === 2) {
        startDate = this.$moment(this.dateRange[0])
          .startOf('day')
          .format('YYYY-MM-DDTHH:mm:ssZ')
        endDate = this.$moment(this.dateRange[1])
          .endOf('day')
          .format('YYYY-MM-DDTHH:mm:ssZ')
      }
      await getTransferWarehouseList({
        business_id: this.params.business_id,
        warehouse_id: this.params.warehouse_id,
        selectedWarehouseId: this.selectedWarehouseId,
        page: this.params.page,
        size: this.params.size,
        sorting,
        filter: filters.length ? filters.join(',') : undefined,
        start_date: startDate,
        end_date: endDate,
      })
        .then(({ data }) => {
          this.listData = data.data || data.content || []
          this.totalRow = data.total_count ?? data.total_of_elements ?? 0
        })
        .catch(err => {
          this.listData = []
          this.totalRow = 0
          console.error(err)
        })
        .finally(() => (this.isLoading = false))
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .includes(input.toLowerCase())
    },
    getWarehouseName(warehouse_id) {
      if (!warehouse_id) return '-'
      // Use fullWarehouseList for lookup to avoid "-" when user has limited access
      const findWarehouse = this.fullWarehouseList.find(
        item => String(item.value) === String(warehouse_id),
      )
      return findWarehouse?.label || '-'
    },
    onPageChange(pageNumber) {
      this.params.page = pageNumber
      this.fetchList()
    },
    onShowSizeChange(current, pageSize) {
      this.params.page = current
      this.params.size = pageSize
      this.fetchList()
    },
    toCreateTransfer() {
      this.$router.push({
        name: 'inventory.transfer.stock.create',
        query: {
          ...this.$route.query,
          warehouseId:
            this.$route.query.warehouse_id || this.$route.query.warehouseId,
        },
      })
    },
    toImportTransfer() {
      this.$router.push({
        name: 'inventory.transfer.stock.import',
        query: {
          ...this.$route.query,
        },
      })
    },
    async copyToClipboard(text, successKey, errorKey) {
      try {
        const value = String(text || '')
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(value)
        } else {
          const el = document.createElement('textarea')
          el.value = value
          el.setAttribute('readonly', '')
          el.style.position = 'absolute'
          el.style.left = '-9999px'
          document.body.appendChild(el)
          el.select()
          document.execCommand('copy')
          document.body.removeChild(el)
        }
        this.$message.success(this.$t(successKey))
      } catch (e) {
        this.$message.error(this.$t(errorKey))
      }
    },
    async copyNumber(text) {
      await this.copyToClipboard(
        text,
        'transferStock.messages.copySuccess',
        'transferStock.messages.copyError',
      )
    },
    normalizeStatus(s) {
      const val =
        s == null || s === undefined || s === ''
          ? 'RECEIVED'
          : String(s).toUpperCase()
      return val
    },
    statusColor(s) {
      const v = this.normalizeStatus(s)
      if (v === 'CREATED') return 'geekblue'
      if (v === 'SHIPPED') return 'green'
      if (v === 'RECEIVED') return 'green'
      if (v === 'CANCELED') return 'volcano'
      return 'default'
    },
    viewDetail(record) {
      const id = record?.id
      if (!id) return
      this.$router.push({
        name: 'inventory.transfer.stock.detail',
        params: { id: String(id) },
        query: { ...this.$route.query, number: record?.number },
      })
    },
    shipTransfer(record) {
      const id = record?.id
      const number = record?.number
      if (!id) return
      this.$confirm({
        title: this.$t('transferStock.confirm.sendTitle'),
        content: this.$t('transferStock.confirm.sendContent', {
          value: number || id,
        }),
        okText: this.$t('transferStock.confirm.okSend'),
        cancelText: this.$t('transferStock.confirm.cancelText'),
        onOk: () => this.doSendTransfer(id),
      })
    },
    async doSendTransfer(id) {
      try {
        this.isLoading = true
        const { data } = await getTransferWarehouseDetail(id, {
          business_id: this.params.business_id,
        })
        const d = data.data || data || {}
        const items = (d.line_items || d.items || []).map(it => ({
          id: it.id,
          catalog_id: String(it.catalog_id || ''),
          catalog_title: it.catalog_title || it.title || '',
          quantity: Number(it.quantity ?? 0),
          unit: it.unit || 'PCS',
          sku: it.sku || '',
        }))
        const payload = {
          id: String(d.id || id),
          number: d.number,
          date: d.date
            ? this.$moment(d.date).format('YYYY-MM-DDTHH:mm:ssZ')
            : this.$moment().format('YYYY-MM-DDTHH:mm:ssZ'),
          note: d.note || '',
          type: 'TWH',
          source_warehouse_id: String(d.source_warehouse_id || ''),
          source_business_id: String(this.params.business_id),
          destination_warehouse_id: String(d.destination_warehouse_id || ''),
          destination_business_id: String(this.params.business_id),
          created_at: d.created_at || null,
          updated_at: d.updated_at || null,
          status: String(d.status || 'CREATED').toUpperCase(),
          line_items: items,
        }
        await sendTransferNonWms({
          business_id: this.params.business_id,
          data: payload,
        })
        this.$message.success(this.$t('transferStock.success.send'))
        this.fetchList()
      } catch (e) {
        this.notifyError(e)
      } finally {
        this.isLoading = false
      }
    },
    receiveTransfer(record) {
      const id = record?.id
      const number = record?.number
      if (!id) return
      this.$confirm({
        title: this.$t('transferStock.confirm.receiveTitle'),
        content: this.$t('transferStock.confirm.receiveContent', {
          value: number || id,
        }),
        okText: this.$t('transferStock.confirm.okReceive'),
        cancelText: this.$t('transferStock.confirm.cancelText'),
        onOk: () => this.doReceiveTransfer(id),
      })
    },
    async doReceiveTransfer(id) {
      try {
        this.isLoading = true
        const { data } = await getTransferWarehouseDetail(id, {
          business_id: this.params.business_id,
        })
        const d = data.data || data || {}
        const items = (d.line_items || d.items || []).map(it => ({
          id: it.id,
          catalog_id: String(it.catalog_id || ''),
          catalog_title: it.catalog_title || it.title || '',
          quantity: Number(it.quantity ?? 0),
          unit: it.unit || 'PCS',
          sku: it.sku || '',
        }))
        const payload = {
          id: String(d.id || id),
          number: d.number,
          date: d.date
            ? this.$moment(d.date).format('YYYY-MM-DDTHH:mm:ssZ')
            : this.$moment().format('YYYY-MM-DDTHH:mm:ssZ'),
          note: d.note || '',
          type: 'TWH',
          source_warehouse_id: String(d.source_warehouse_id || ''),
          source_business_id: String(this.params.business_id),
          destination_warehouse_id: String(d.destination_warehouse_id || ''),
          destination_business_id: String(this.params.business_id),
          created_at: d.created_at || null,
          updated_at: d.updated_at || null,
          status: String(d.status || 'SHIPPED').toUpperCase(),
          line_items: items,
        }
        await receiveTransferNonWms({
          business_id: this.params.business_id,
          data: payload,
        })
        this.$message.success(this.$t('transferStock.success.receive'))
        this.fetchList()
      } catch (e) {
        this.notifyError(e)
      } finally {
        this.isLoading = false
      }
    },
    cancelTransfer(record) {
      const id = record?.id
      const number = record?.number
      if (!id) return
      this.$confirm({
        title: this.$t('transferStock.confirm.cancelTitle'),
        content: this.$t('transferStock.confirm.cancelContent', {
          value: number || id,
        }),
        okText: this.$t('transferStock.confirm.okCancel'),
        cancelText: this.$t('transferStock.confirm.cancelText'),
        onOk: () => this.doCancelTransfer(id),
      })
    },
    async doCancelTransfer(id) {
      try {
        this.isLoading = true
        const { data } = await getTransferWarehouseDetail(id, {
          business_id: this.params.business_id,
        })
        const d = data.data || data || {}
        const items = (d.line_items || d.items || []).map(it => ({
          id: it.id,
          catalog_id: String(it.catalog_id || ''),
          catalog_title: it.catalog_title || it.title || '',
          quantity: Number(it.quantity ?? 0),
          unit: it.unit || 'PCS',
          sku: it.sku || '',
        }))
        const payload = {
          id: String(d.id || id),
          number: d.number,
          date: d.date
            ? this.$moment(d.date).format('YYYY-MM-DDTHH:mm:ssZ')
            : this.$moment().format('YYYY-MM-DDTHH:mm:ssZ'),
          note: d.note || '',
          type: 'TWH',
          source_warehouse_id: String(d.source_warehouse_id || ''),
          source_business_id: String(this.params.business_id),
          destination_warehouse_id: String(d.destination_warehouse_id || ''),
          destination_business_id: String(this.params.business_id),
          created_at: d.created_at || null,
          updated_at: d.updated_at || null,
          status: String(d.status || 'CREATED').toUpperCase(),
          line_items: items,
        }
        await cancelTransferNonWms({
          business_id: this.params.business_id,
          data: payload,
        })
        this.$message.success(this.$t('transferStock.success.cancel'))
        this.fetchList()
      } catch (e) {
        this.notifyError(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep(.ant-table-body) {
  max-height: calc(100vh - 326px) !important;
}
.data-list {
  .list-title {
    font-weight: bold;
  }
  .list-info {
    font-size: 12px;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    white-space: nowrap;
  }
  .ant-table-tbody > tr > td {
    vertical-align: middle;
  }
  ::v-deep(.ant-table-row) {
    cursor: pointer;
  }
}
.mono-sm {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    'Liberation Mono', 'Courier New', monospace;
  font-size: 12px;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cell-number {
  display: flex;
  align-items: center;
}
.cell-number .mono-sm {
  min-width: 0;
}
.copy-icon {
  margin-left: 8px;
  cursor: pointer;
}
.cell-date {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
}
::v-deep(.ant-pagination-options-size-changer.ant-select) {
  margin-right: 0px;
}
.actor-ellipsis,
.wh-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
}
.cell-warehouse,
.cell-actor {
  text-align: center;
}
.catalog-list {
  border: 1px solid #e4e9f0;
  width: 100%;
  border-collapse: collapse;
  tr > th {
    padding: 10px;
    font-weight: 500;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e4e9f0;
    text-align: left;
  }
  tr > td {
    padding: 8px 10px;
    background-color: #fff;
    border-bottom: 1px solid #e4e9f0;
  }
}
.data-list .ant-table-body {
  max-height: calc(100vh - 370px) !important;
  overflow-y: auto !important;
}
</style>
